import React from 'react';
import { FaBuilding, FaGlobe, FaCheck } from 'react-icons/fa';
import CompanySearch from './CompanySearch';

interface Company {
  id: number;
  name: string;
  business_name?: string;
}

interface CompanySelectionProps {
  selectedCompany: Company | null;
  onCompanySelect: (company: Company) => void;
  onClearSelection: () => void;
  onLoadProperties: () => void;
  isLoadingProperties: boolean;
  propertiesLoaded: boolean;
  propertiesData: any;
}

const CompanySelection: React.FC<CompanySelectionProps> = ({
  selectedCompany,
  onCompanySelect,
  onClearSelection,
  onLoadProperties,
  isLoadingProperties,
  propertiesLoaded,
  propertiesData
}) => {
  return (
    <div className="bg-white rounded-xl p-6 shadow-sm border">
      <div className="flex items-center gap-3 mb-4">
        <FaBuilding size={20} className="text-blue-600" />
        <h2 className="text-lg font-semibold text-gray-900">Company Selection</h2>
      </div>
      
      <div className="space-y-3">
        {/* Company Search Input */}
        <CompanySearch
          selectedCompany={selectedCompany}
          onCompanySelect={onCompanySelect}
          onClearSelection={onClearSelection}
        />

        {/* Load Properties Button */}
        <button
          onClick={onLoadProperties}
          disabled={!selectedCompany || isLoadingProperties}
          className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200 flex items-center justify-center gap-2"
        >
          {isLoadingProperties ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
              Loading...
            </>
          ) : (
            <>
              <FaGlobe size={16} />
              Load Properties
            </>
          )}
        </button>

        {/* Success Message */}
        {propertiesLoaded && selectedCompany && (
          <div className="p-3 bg-green-50 border border-green-200 rounded-lg">
            <div className="flex items-center text-green-800">
              <FaCheck className="mr-2" />
              <span className="text-sm font-medium">
                Successfully loaded {propertiesData?.total || 0} properties for {selectedCompany.name || selectedCompany.business_name || `Company ID ${selectedCompany.id}`}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CompanySelection;
